<template>
  <v-container>
    <ValidationObserver ref="observer" v-slot="{ invalid, valid }">
      <v-card>
        <v-card-title style="font-weight: bold">Change My Password</v-card-title>
        <v-card-text>
          <validation-provider v-slot="{ errors }" name="old password" rules="required">
            <v-text-field
              v-model="form.oldPw"
              :error-messages="errors"
              label="old password"
              outlined
              type="password"
            />
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: true, regex: /^.{5,}$/ }"
            name="new password"
            vid="confirm"
          >
            <v-text-field
              v-model="form.newPw"
              :error-messages="errors && errors.length ? 'Must be 5 characters or more' : ''"
              label="new password"
              outlined
              type="password"
            />
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            name="confirm new password"
            rules="required|confirmed:confirm"
          >
            <v-text-field
              v-model="form.confirmNewPw"
              :error-messages="errors"
              label="confirm new password"
              outlined
              type="password"
            />
          </validation-provider>
        </v-card-text>
      </v-card>
      <v-btn
        :disabled="!valid"
        class="mt-4 buttonClicked"
        color="primary"
        @click.stop="changePassword"
      >
        Change Password
      </v-btn>
    </ValidationObserver>
  </v-container>
</template>

<script>
import api from '@/api';
import { changeMyPassword } from '@/api/auth';

export default {
  data() {
    return {
      form: {
        oldPw: null,
        newPw: null,
        confirmNewPw: null,
      },
    };
  },
  methods: {
    async changePassword() {
      try {
        await changeMyPassword(api, {
          ...this.form,
        });
        alert('Change password success');
        this.form = {
          oldPw: null,
          newPw: null,
          confirmNewPw: null,
        };
        await this.$refs.observer?.reset();
        await this.$router.push('/');
      } catch (e) {
        alert('Change password fail');
      }
    },
  },
};
</script>
